export const LocalStorageKeys = {
  appNotificationsEnabled: 'app-notifications-enabled',
};
